export class ValidationMessageError {
    status: boolean;
    statusCode: number;
    intlCode: number
    errorType: string;
    statusInfo: string;
    internalMessage: string;
    constructor(intlCode: number, statusInfo: string) {
        this.status = false;
        this.statusCode = 10001;
        this.intlCode = intlCode;
        this.errorType = 'Validation Message';
        this.statusInfo = statusInfo;
        this.internalMessage = statusInfo;
    }
}
